/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  EditReport: (params: vp.EditReportRequest) => void,
  reset: () => void,
  EditReportAsync: (params: vp.EditReportRequest) => Promise<vp.ApiResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostEditReport: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldEditReport, setShouldEditReport] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.EditReportRequest>({
    PortalUser: '',
    SubscriptionID: '',
    IsActive: '',
    ReportName: '',
    Description: '',
    DateFormat: '',
    ScheduleType: '',
    FromDate: '',
    ToDate: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldEditReport) return () => {};

    const PostEditReport = async () => {
      setDataFetchingInfo(true, 'Loading', 'fullScreen');
      const res = await api.postEditReport(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldEditReport) void PostEditReport();
    setShouldEditReport(false);
    return () => {
      source.cancel();
    };
  }, [shouldEditReport]);

  return [
    response,
    (_params: vp.EditReportRequest) => {
      setParams(_params);
      setShouldEditReport(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldEditReport(false);
    },
    (_params: vp.EditReportRequest) => api.postEditReport(_params, source),
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostEditReport);
